module.exports = __webpack_public_path__ + "img/mobile-screenshots.f7dc3ba4.png";